import { render, staticRenderFns } from "./AppListItem.vue?vue&type=template&id=0a1028d2&scoped=true&"
import script from "./AppListItem.vue?vue&type=script&lang=ts&"
export * from "./AppListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppListItem.vue?vue&type=style&index=0&id=0a1028d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1028d2",
  null
  
)

export default component.exports